module.exports = __webpack_public_path__ + "static/img/fish13.fa479bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish13.png
// module id = 6Pje
// module chunks = 0